<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <el-button type="primary" size="small" @click="add">新 增</el-button>
      <div>
        <el-input
          clearable
          style="width: 250px"
          v-model.trim="searchCondition.textName"
          placeholder="请输入名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-input
          clearable
          style="width: 250px"
          v-model.trim="searchCondition.textCode"
          placeholder="请输入编码"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="textName"
          label="文本名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="textContentZhCn"
          label="文本内容"
          width="400"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="textCode"
          label="文本编码"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="textType"
          label="文本类型"
        >
        </el-table-column>

        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="创建时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="updateTime"
          label="更新时间"
        >
        </el-table-column> -->
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="200px"
        >
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="edit(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :before-close="handleClose"
      :visible.sync="dialogVisible"
      :title="title"
    >
      <el-form
        v-if="dialogVisible"
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="文本名称" prop="textName">
          <el-input
            style="width:300px"
            v-model.trim="ruleForm.textName"
            maxlength="20"
            size="small"
            clearable
            placeholder="请输入单行文本，限制20个字符"
          ></el-input>
        </el-form-item>
        <el-form-item label="文本编码" prop="textCode">
          <el-input
            style="width:300px"
            v-model.trim="ruleForm.textCode"
            maxlength="40"
            size="small"
            clearable
            placeholder="请输入单行文本，限制40个字符"
          ></el-input>
        </el-form-item>
        <el-form-item label="文本类型" prop="textType">
          <el-select
            :disabled="title === '编辑'"
            size="small"
            style="width:300px"
            clearable
            placeholder="选择文本类型"
            v-model="ruleForm.textType"
            class="mr10"
          >
            <el-option
              v-for="(item, i) in textList"
              :key="i"
              :label="item.itemText"
              :value="item.itemValue"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文本内容" prop="textContentZhCn">
          <hm-rich-editor
            v-if="ruleForm.textType === 'rich_text'"
            v-model="ruleForm.textContentZhCn"
            :html="ruleForm.textContentZhCn"
          />

          <el-input
            clearable
            style="width:300px"
            v-else
            :type="ruleForm.textType === 'number' ? 'number' : 'textarea'"
            v-model.trim="ruleForm.textContentZhCn"
            size="small"
            placeholder="请输入文本内容"
          ></el-input>
          <div class="form-item-tip" v-if="ruleForm.textType === 'array'">
            数组用"|"分割
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitForm('ruleForm')" size="small" type="primary"
          >保存</el-button
        >
        <el-button @click="handleClose" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import HmRichEditor from "@/components/HmRichEditor";
export default {
  components: {
    HmRichEditor
  },
  data() {
    return {
      title: "",
      textList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      list: [],
      searchCondition: {},
      dialogVisible: false,
      ruleForm: {
        textName: "",
        textCode: "",
        textType: "",
        textContentZhCn: ""
      },
      rules: {
        textName: {
          required: true,
          trrger: "blur",
          message: "请输入文本名称"
        },
        textCode: {
          required: true,
          trrger: "blur",
          message: "请输入文本编码"
        },
        textType: {
          required: true,
          trrger: "blur",
          message: "请选择文本类型"
        },
        textContentZhCn: {
          required: true,
          trrger: "blur",
          message: "请输入文本内容"
        }
      },
      row: {}
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
    this.queryTextType();
  },
  methods: {
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    edit(row) {
      this.row = row;
      this.title = "编辑";
      this.dialogVisible = true;
      for (let key in row) {
        if (this.ruleForm.hasOwnProperty(key)) {
          this.ruleForm[key] = row[key];
        }
      }
    },
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        let params = this.ruleForm;
        // let name =
        //   this.title === "新增"
        //     ? "addInterfaceTextInfo"
        //     : "editInterfaceTextInfo";
        if (this.title === "编辑") {
          params.textId = this.row.textId;
        }
        if(this.title === "新增") {
          delete params.textId;
        }
        const { code } = await this.$store.dispatch(
          "addInterfaceTextInfo",
          params
        );
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.resetRuleForm();
          this.dialogVisible = false;

          this.queryList();
        }
      }
    },
    async queryTextType() {
      const { result } = await this.$store.dispatch("queryTextType");
      this.textList = result;
    },
    resetRuleForm() {
      // this.$nextTick(() => {});
      //
      setTimeout(() => {
        this.ruleForm.textName = "";
        this.ruleForm.textCode = "";
        this.ruleForm.textType = "";
        this.ruleForm.textContentZhCn = "";
      }, 0);
      this.$refs.ruleForm.resetFields();
    },
    handleClose() {
      this.resetRuleForm();
      this.dialogVisible = false;
    },
    add() {
      this.title = "新增";
      this.dialogVisible = true;
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "interfaceTextInfoList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped></style>
